import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { toast } from "sonner";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const token = params.get("token") || "";
    const nav = useNavigate();
    const [password, setPassword] = useState("");
    const [confirm, setConfirm] = useState("");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    if (!token) {
        return (
            <div>
                <Header />
                <div className="max-w-md mx-auto px-6 py-16">
                    <div className="sd-card p-8 fade-up">
                        <h1 className="font-display text-2xl mb-4">Lien invalide</h1>
                        <p className="text-sm text-slate-600 mb-6">
                            Ce lien de réinitialisation ne contient pas le jeton
                            nécessaire. Merci de demander un nouvel e-mail.
                        </p>
                        <Link to="/mot-de-passe-oublie" className="btn-gold w-full text-center block">
                            Demander un nouveau lien
                        </Link>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        if (password.length < 8) {
            setError("Le mot de passe doit contenir au moins 8 caractères.");
            return;
        }
        if (password !== confirm) {
            setError("Les deux mots de passe ne correspondent pas.");
            return;
        }
        setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, password });
            toast.success("Mot de passe mis à jour, vous pouvez vous reconnecter.");
            nav("/connexion");
        } catch (err) {
            setError(err?.response?.data?.detail || "Impossible de réinitialiser le mot de passe.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div>
            <Header />
            <div className="max-w-md mx-auto px-6 py-16">
                <div className="sd-card p-8 fade-up">
                    <div className="overline mb-2">Nouveau mot de passe</div>
                    <h1 className="font-display text-3xl mb-4">Un mot de passe tout neuf.</h1>
                    <p className="text-sm text-slate-600 mb-6">
                        Choisissez un mot de passe fort — <b>8 caractères minimum</b>.
                    </p>
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-semibold mb-1">
                                Nouveau mot de passe
                            </label>
                            <input
                                type="password"
                                required
                                minLength={8}
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-slate-200 focus-ring bg-white"
                                data-testid="reset-password-input"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-semibold mb-1">
                                Confirmer le mot de passe
                            </label>
                            <input
                                type="password"
                                required
                                minLength={8}
                                value={confirm}
                                onChange={(e) => setConfirm(e.target.value)}
                                className="w-full px-4 py-3 rounded-xl border border-slate-200 focus-ring bg-white"
                                data-testid="reset-password-confirm"
                            />
                        </div>
                        {error && (
                            <div className="text-sm text-red-600" data-testid="reset-error">
                                {error}
                            </div>
                        )}
                        <button
                            disabled={loading}
                            className="btn-gold w-full"
                            data-testid="reset-submit-btn"
                        >
                            {loading ? "Enregistrement..." : "Enregistrer"}
                        </button>
                    </form>
                </div>
            </div>
            <Footer />
        </div>
    );
}
